import React, {useEffect} from 'react';
import './Header.css';
import AOS from "aos";
import "aos/dist/aos.css";
import yuhu from "../../assets/image/circle-spinner.png";
const Header = (props) => {

useEffect(() =>{
  AOS.init({
    duration: 1000,
    easing: "ease",
  })
}, []);

  return (
    <>
      <div className='container-head flex w-full justify-center' id='container-head'>
        <div className='_box-content text-center flex w-full flex-col justify-center items-center h-auto gap-5'>
          <div className='col-heder flex w-full justify-center items-baseline gap-4'>
            <p data-aos='fade-up'>{props.data.title}</p>
            <img
              src={props.data.img}
              alt=''
              srcset=''
              className='img-kopo'
              data-aos='fade-up'
            />
          </div>
          <p className='font-border' data-aos='fade-up'>
            {props.data.description}
          </p>
        </div>
      </div>
    </>
  );
}

export default Header
